import Splide from '@splidejs/splide'

let partnersInstance = null

export function initPartnersCarousel() {
  const carousel = document.querySelector('.sdcc-partners__mobile')
  if (!carousel) return

  const vw = window.innerWidth

  if (vw < 768) {
    if (!partnersInstance) {
      let rightPadding = '60px'

      if (vw <= 375) {
        rightPadding = '60px'
      } else if (vw <= 414) {
        rightPadding = '60px'
      } else if (vw <= 480) {
        rightPadding = '30px'
      } else {
        rightPadding = '80px'
      }

      partnersInstance = new Splide('.sdcc-partners__mobile', {
        type:         'loop',
        fixedWidth:   'calc(100vw - 40px)',
        perPage:      1,
        perMove:      1,
        gap:          '16px',
        padding:      { left: '0px', right: '0px' },
        pagination:   true,
        arrows:       false,
        width:        '100%',
        autoplay:     true,
        interval:     4000,
        pauseOnHover: true,
      }).mount()
    }
  } else {
    if (partnersInstance) {
      partnersInstance.destroy(true)
      partnersInstance = null
    }
  }
}